module.exports = __webpack_public_path__ + "static/profile-40d2ab5d559fe007e43bee993174a747.jpg";